import { ReactNode } from "react";

interface Props {
  /** The reassuring line. Never "No data." — always warm and human. */
  message: ReactNode;
  /** Optional smaller line beneath. */
  detail?: ReactNode;
  icon?: ReactNode;
}

/**
 * The Quiet Empty State. Empty is not an error — it's peace. Ivory paper,
 * soft muted copy, no illustrations that shout. See mem/constitution/silver-sage-principles.md.
 */
export function QuietEmptyState({ message, detail, icon }: Props) {
  return (
    <div className="paper-card p-8 text-center space-y-2">
      {icon && <div className="mx-auto text-muted-foreground/50">{icon}</div>}
      <p className="text-sm text-foreground/80">{message}</p>
      {detail && <p className="text-xs text-muted-foreground">{detail}</p>}
    </div>
  );
}
